import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';

var _React$createContext = React.createContext(),
    Consumer = _React$createContext.Consumer,
    Provider = _React$createContext.Provider;

var withScrollingConsumer = function withScrollingConsumer(Component) {
  var Wrapper = function Wrapper(props) {
    return React.createElement(Consumer, null, function (data) {
      return React.createElement(Component, _extends({}, data, props));
    });
  };

  Wrapper.displayName = 'withScrollingConsumer(' + Component.displayName + ')';
  return Wrapper;
};

export { Consumer, Provider, withScrollingConsumer };